import { Helmet } from "react-helmet";

import { APP_NAME } from "../../settings/constants";

interface PageTitleProps {
  title: string;
  withAppTitle: boolean;
}

export const PageTitle = (props: PageTitleProps) => {
  const { title, withAppTitle } = props;

  return (
    <Helmet>
      <title>{withAppTitle ? `${APP_NAME} - ${title}` : title}</title>
    </Helmet>
  );
};

PageTitle.defaultProps = {
  withAppTitle: true,
};
